import "./CampusesPage.css";
import { useState, useEffect } from "react";
import { addEmailToList } from '../emailSignup';
import { fetchCampuses } from '../fetchCampuses';

function CampusesPage() {
  const [userEmail, setUserEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [campuses, setCampuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch campuses on component mount
  useEffect(() => {
    const loadCampuses = async () => {
      try {
        setLoading(true);
        const campusData = await fetchCampuses();
        setCampuses(campusData);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Failed to load campuses:", err);
      } finally {
        setLoading(false);
      }
    };

    loadCampuses();
  }, []);

  const handleChange = (event) => {
    setUserEmail(event.target.value);
  };

  const submitPressed = async (event) => {
    event.preventDefault();
    const result = await addEmailToList(userEmail);
    setSuccessMessage(result.message);
    if (result.success) {
      setUserEmail("");
    }
  };

  // Calculate percentage for progress bar
  const getProgressPercentage = (signupCount, threshold) => {
    const percentage = (signupCount / threshold) * 100;
    return Math.min(percentage, 100); // Cap at 100%
  };

  return (
    <div className="Campuses-content">
      <div className="glass-card campuses-card">
        <h1 className="campuses-title">Join the Waitlist</h1>
        <p className="campuses-subtitle">
          See which campuses are joining Geomatchry. Help your school get access by joining our email list.
        </p>

        {/* Email Signup Form */}
        <form onSubmit={submitPressed} className="email-form">
          <div className="input-span">
            <input
              type="email"
              className="user-text-input"
              placeholder="Your email here..."
              value={userEmail}
              onChange={handleChange}
            />
            <button type="submit" className="user-button">
              Join
            </button>
          </div>
        </form>

        {successMessage && (
          <div className="message-display">
            {successMessage}
          </div>
        )}

        {/* Campus List Section */}
        <div className="campus-list-container">
          <h2 className="campus-list-title">Campus Progress</h2>
          
          {loading && (
            <div className="loading-message">
              Loading campuses...
            </div>
          )}

          {error && (
            <div className="error-message">
              <p>Unable to load campus data.</p>
              <p className="error-details">{error}</p>
            </div>
          )}

          {!loading && !error && campuses.length === 0 && (
            <div className="empty-message">
              No campuses available yet. Check back soon.
            </div>
          )}

          {!loading && !error && campuses.length > 0 && (
            <div className="campus-list">
              {campuses.map((campus, index) => {
                const progressPercentage = getProgressPercentage(
                  campus.signupCount, 
                  campus.threshold
                );
                const isComplete = campus.signupCount >= campus.threshold;
                
                return (
                  <div key={campus.domain || index} className="campus-item">
                    <div className="campus-header">
                      <h3 className="campus-name">{campus.name}</h3>
                      <span className="campus-domain">{campus.domain}</span>
                    </div>
                    
                    <div className="campus-stats">
                      <span className="signup-count">
                        {campus.signupCount} / {campus.threshold} signups
                      </span>
                      {isComplete && (
                        <span className="complete-badge">✓ Threshold Met!</span>
                      )}
                    </div>
                    
                    <div className="progress-bar-container">
                      <div 
                        className={`progress-bar ${isComplete ? 'complete' : ''}`}
                        style={{ width: `${progressPercentage}%` }}
                      >
                        <div className="progress-shine"></div>
                      </div>
                    </div>
                    
                    <div className="progress-percentage">
                      {progressPercentage.toFixed(1)}% to launch
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CampusesPage;